// LSP0
export const SETDATA_ERC725Y = 'setData(bytes32,bytes)'
export const SETDATA_BATCH_ERC725Y = 'setDataBatch(bytes32[],bytes[])'

export const EXECUTE_BATCH_ERC725X =
  'executeBatch(uint256[],address[],uint256[],bytes[])'

export const DEPLOY = 'deploy(bytes32,bytes)'

export const TRANSFER_OWNERSHIP_LSP0 = 'transferOwnership(address)'
export const ACCEPT_OWNERSHIP_LSP0 = 'acceptOwnership()'
export const RENOUNCE_OWNERSHIP_LSP0 = 'renounceOwnership()'

// Other mint functions
export const MINT_BURNTPIX = 'mint(address,uint32)'

// LSP7
export const MINT_LSP7 = 'mint(address,uint256,bool,bytes)'
export const TRANSFER_LSP7 = 'transfer(address,address,uint256,bool,bytes)'
export const AUTHORIZE_OPERATOR_LSP7 =
  'authorizeOperator(address,uint256,bytes)'
export const REVOKE_OPERATOR_LSP7_V12 = 'revokeOperator(address,bool,bytes)'
export const REVOKE_OPERATOR_LSP7_V15 =
  'revokeOperator(address,address,bool,bytes)'

// LSP8
export const MINT_LSP8 = 'mint(address,bytes32,bool,bytes)'
export const TRANSFER_LSP8 = 'transfer(address,address,bytes32,bool,bytes)'
export const AUTHORIZE_OPERATOR_LSP8 =
  'authorizeOperator(address,bytes32,bytes)'
export const REVOKE_OPERATOR_LSP8 = 'revokeOperator(address,bytes32,bool,bytes)'

// LSP26 Follower System
export const FOLLOW_LSP26 = 'follow(address)'
export const UNFOLLOW_LSP26 = 'unfollow(address)'

// ERC20
export const MINT_ERC20 = 'mint(address,uint256)'
export const BURN_ERC20 = 'burn(uint256)'
export const BURN_FROM_ERC20 = 'burnFrom(address,uint256)'
export const TRANSFER_ERC20 = 'transfer(address,uint256)'
export const APPROVE_ERC20 = 'approve(address,uint256)'

// ERC721
export const MINT_ERC721 = 'mint(address,uint256)'
export const SAFE_MINT_ERC721 = 'safeMint(address,uint256)'
export const BURN_ERC721 = 'burn(uint256)'
export const TRANSFER_FROM_ERC721 = 'transferFrom(address,address,uint256)'
export const APPROVE_ERC721 = 'approve(address,uint256)'

// ERC777
export const SEND_ERC777 = 'send(address,uint256,bytes)'
export const BURN_ERC777 = 'burn(uint256,bytes)'
export const OPERATOR_SEND_ERC777 =
  'operatorSend(address,address,uint256,bytes,bytes)'
export const OPERATOR_BURN_ERC777 = 'operatorBurn(address,uint256,bytes,bytes)'
export const AUTHORIZE_OPERATOR_ERC777 = 'authorizeOperator(address)'

// ERC1155
export const MINT_ERC1155 = 'mint(address,uint256,uint256,bytes)'
export const SAFE_TRANSFER_FROM_ERC1155 =
  'safeTransferFrom(address,address,uint256,uint256,bytes)'
